export enum ETabs {
  ASSISTANT = "assistant-start",
  ORTHO_PRACTICES = "ortho-practices",
  GP_PRACTICES = "gp-practices",
  CONTRACTS = "contracts",
  ORTHO_OFFICES = "ortho-offices",
  GP_OFFICES = "gp-offices",
  MEMBERS = "members",
  MSOS = "msos",
  REPORTS = "reports",
}
